module.exports = __webpack_public_path__ + "img/MONEY.c04c343d.svg";